import { Text } from '@pm/ui';
import { JSX } from 'react';
export const IconListItem = ({
  textContent,
  icon,
  textSize = 'bodyL',
}: {
  textContent?: string;
  icon: JSX.Element;
  textSize?:
    | 'bodyL'
    | 'label'
    | 'headingXL'
    | 'headingL'
    | 'headingM'
    | 'headingS'
    | 'headingXS'
    | 'bodyS'
    | 'buttonL'
    | 'buttonS'
    | 'labelStrong'
    | null
    | undefined;
}) => {
  const isSmall = textSize === 'bodyS' || textSize === 'label';
  return (
    <div
      className={`flex flex-row ${isSmall ? 'gap-x-xs' : 'gap-x-m'} items-center`}
    >
      {icon}
      <Text size={textSize}>{textContent}</Text>
    </div>
  );
};
